// mds-dojo — dojo/_base/config — the runtime config bag. dojo built this from
// djConfig / data-dojo-config / the loader; in Vite there's no loader, so we expose
// the same defaults + let a host set overrides on window.dojoConfig before load.
// Widgets read config.blankGif, config.isDebug, config.locale, etc.

const w: any = (typeof window != 'undefined') ? window : globalThis;
const userConfig: any = w.dojoConfig || w.djConfig || {};

const config: any = {
  isDebug: false,
  locale: (typeof navigator != 'undefined' && (navigator.language || (navigator as any).userLanguage)) || 'en-us',
  // 1x1 transparent gif (data URI so no network fetch / broken-image)
  blankGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
  defaultDuration: 200,
};

// apply host overrides
for (const k in userConfig) {
  if (userConfig.hasOwnProperty(k)) { config[k] = userConfig[k]; }
}

export default config;
